export default {
  refundEnabled: function() {
    return this.$store.state.user?.agency?.id === 290
  }
}
